import IconButton from 'components/common/IconButton';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { getSearches, updateAlertType } from 'redux/searchesSlice';
import { alertTypes } from './alertsModels';

const AlertItem = ({ data: { name, tags, alerts, id }, handleDelete }) => {
  const dispatch = useDispatch();
  const userLogged = useSelector(state => state.login.currentUser);

  const [alertValue, setAlertValue] = useState(
    alertTypes.find(al => al.type === alerts).type
  );

  const options = [
    { value: 'Sin alertas', label: 'Sin alertas' },
    { value: 'Inmediatas', label: 'Inmediatas' },
    { value: 'Diarias', label: 'Diarias' }
  ];

  const ChangeAlert = async selectedOption => {
    const value = selectedOption.value;
    await dispatch(
      updateAlertType(id, {
        alerts: value
      })
    );
    setAlertValue(value);
    dispatch(getSearches(userLogged.id));
  };

  return (
    <div className="py-3 border-bottom">
      <Row>
        <Col xs={12} sm={6} md={12} lg={3}>
          <h5 className="mb-0">{name}</h5>
        </Col>

        <Col xs={12} sm={6} md={12} lg={3}>
          {tags.map(tag => (
            <div key={tag}>{tag}</div>
          ))}
        </Col>

        <Col xs={12} sm={6} md={12} lg={3}>
          <Select
            options={options}
            value={options.find(option => option.value === alertValue)}
            onChange={ChangeAlert}
          />
        </Col>

        <Col xs={12} sm={6} md={12} lg={3}>
          <div className="mb-3 d-block d-lg-flex" style={{ gap: 10 }}>
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip>Eliminar</Tooltip>}
            >
              <div className="d-grid">
                <IconButton
                  buttonSize="sm"
                  icon="trash-can"
                  onClick={handleDelete}
                  variant="danger"
                  className="px-2 mt-1"
                />
              </div>
            </OverlayTrigger>
          </div>
        </Col>
      </Row>
    </div>
  );
};

AlertItem.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tags: PropTypes.array.isRequired,
    alerts: PropTypes.string.isRequired
  }),
  handleDelete: PropTypes.func.isRequired
};

export default AlertItem;
